module.exports = __webpack_public_path__ + "img/10.d4f12e5a.svg";